import { Box, Stack } from "@mui/material";

export type TruxFormFieldProps = {
  label: React.ReactNode,
  children: React.ReactNode
  maxWidth?: string
}

export default function TruxFormField({ label, children, maxWidth }: TruxFormFieldProps) {

  return <Stack direction="row" gap={2} flexGrow={1}>
    <Box component="label" sx={{ flex: "1", maxWidth: maxWidth || "150px", paddingTop: "5px" }}>
      {label}
    </Box>
    <Box component="div" sx={{ flex: "2", minWidth: 0 }}>
      {children}
    </Box>
  </Stack>

}